var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.825 26.19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "streamline-icon-multiple-neutral-1@140x140",
    fill: "#575757"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M4.002 6.911A6.911 6.911 0 1010.913 0a6.911 6.911 0 00-6.911 6.911z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M21.825 25.463a10.913 10.913 0 00-21.825 0 .727.727 0 00.727.727H21.1a.727.727 0 00.725-.727z"
  }))));
}

export default __webpack_public_path__ + "a2d14d6c84005b833dfcbbe9bf663d0b.svg";
export { SvgUser as ReactComponent };